(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["better-tabbed-charts"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.better-tabbed-charts');

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('.chart-tab');
    const panels = section.querySelectorAll('.chart-panel');

    function activate(tab) {
      const target = tab.getAttribute('data-attr');

      tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const match = panel.id === target;
        panel.classList.toggle('is-active', match);
        panel.hidden = !match;
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));

      tab.addEventListener('keydown', (e) => {
        let newIndex = null;
        if (e.key === 'ArrowRight') newIndex = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft') newIndex = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(tab);
        }
        if (newIndex !== null) {
          e.preventDefault();
          tabs[newIndex].focus();
          activate(tabs[newIndex]);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
